import React from 'react';
import { withRouter } from 'react-router';
import { useIsRole, useIsAdmin, useIsManager } from 'hooks';
import { ROLE } from 'helpers/constants';
import { Button, Select } from 'components/ui/form';
import { Input, Select as SelectFormik } from 'components/ui/formik';
import styles from './info.module.scss';

const Info = ({
  match: {
    params: { userId },
  },
  profile,
  edit,
  onToggleEdit,
  onSubmit,
  onReset,
  onChangeContract,
}) => {
  const isAdmin = useIsAdmin();
  const isManager = useIsManager();
  const isUserProfile = useIsRole([ROLE.USER], profile.role.code);
  const isManagementProfile = useIsRole([ROLE.ADMIN, ROLE.MANAGER], profile.role.code);
  const isProfile = Number(userId) >= 0;

  return (
    <form onSubmit={onSubmit} autoComplete="off">
      <div className={styles.info}>
        <div className={styles.name}>{profile.name}</div>
        <div className={styles.fields}>
          {isUserProfile && profile.contracts && profile.contracts.length ? (
            <>
              <div className={styles.field}>
                <Select
                  label="Договор"
                  name="contracts"
                  onChange={e => onChangeContract(e.target.value)}
                >
                  {profile.contracts.map(
                    contract => (
                      <option
                        key={contract.id}
                        value={contract.id}
                      >
                        {contract.name}
                      </option>
                    ),
                  )}
                </Select>
              </div>
              <div className={styles.field}>
                <Input
                  label="Баланс"
                  name="balance"
                  readOnly
                />
              </div>
            </>
          ) : null}
          {isUserProfile ? (
            <>
              <div className={styles.field}>
                <Input label="ОКПО" placeholder="ОКПО" name="okpo" readOnly={!edit} />
              </div>
              <div className={styles.field}>
                <Input label="Полное наименование" placeholder="Полное наименование" name="name" readOnly={!edit} />
              </div>
              <div className={styles.field}>
                <Input label="Сокращенное наименование" placeholder="Сокращенное наименование" name="shortName" readOnly={!edit} />
              </div>
              <div className={styles.field}>
                <Input label="Юридический адрес организации" placeholder="Юридический адрес организации" name="uAddress" readOnly={!edit} />
              </div>
              <div className={styles.field}>
                <Input label="Почтовый адрес организации" placeholder="Почтовый адрес организации" name="pAddress" readOnly={!edit} />
              </div>
              <div className={styles.field}>
                <Input label="Прочее адрес" placeholder="Прочее адрес" name="oAddress" readOnly={!edit} />
              </div>
              <div className={styles.field}>
                <Input label="Наименование Банка" placeholder="Наименование Банка" name="bankName" readOnly={!edit} />
              </div>
              <div className={styles.field}>
                <Input label="Расчетный счет" placeholder="Расчетный счет" name="personalAccount" readOnly={!edit} />
              </div>
              <div className={styles.field}>
                <Input label="Адрес банка" placeholder="Адрес банка" name="bankAddress" readOnly={!edit} />
              </div>
              <div className={styles.field}>
                <Input label="Официальный E-mail организации" placeholder="Официальный E-mail организации" name="email" readOnly={!edit} />
              </div>
              <div className={styles.field}>
                <Input label="ФИО представителя организации" placeholder="ФИО представителя организации" name="fio" readOnly={!edit} />
              </div>
              <div className={styles.field}>
                <Input label="Телефон представителя организации" placeholder="Телефон представителя организации" name="phone" readOnly={!edit} />
              </div>
              <div className={styles.field}>
                <SelectFormik
                  label="Использовать декадное ограничение"
                  name="decadeLimit"
                  disabled={!edit}
                >
                  {[{ id: 0, caption: 'Нет' }, { id: 1, caption: 'Да' }].map(value => (
                    <option key={value.id} value={value.id}>{value.caption}</option>
                  ))}
                </SelectFormik>
              </div>
            </>
          ) : null}
          {isManagementProfile ? (
            <>
              <div className={styles.field}>
                <Input label="Полное наименование" placeholder="Полное наименование" name="name" readOnly={!edit} />
              </div>
              <div className={styles.field}>
                <Input label="E-mail" placeholder="E-mail" name="email" readOnly={!edit} />
              </div>
            </>
          ) : null}
        </div>
      </div>
      {isAdmin || ((isAdmin || isManager) && !isProfile) ? (
        <div className={styles.buttons}>
          <div className={styles.button}>
            {edit ? (
              <Button
                key={0}
                type="submit"
              >
                Сохранить
              </Button>
            ) : (
              <Button
                key={1}
                color="lightgray"
                onClick={onToggleEdit}
              >
                Изменить
              </Button>
            )}
          </div>
          <div className={styles.button}>
            {edit ? (
              <Button
                key={0}
                color="transparent"
                onClick={() => {
                  onToggleEdit();
                  onReset();
                }}
              >
                Отмена
              </Button>
            ) : null}
          </div>
        </div>
      ) : null}
    </form>
  );
};

export default withRouter(Info);
